<finxone-web-frontend-lottie-animation
  [contentStyle]="contentStyle"
  [lottieWidgetProperties]="lottieWidgetProperties"
></finxone-web-frontend-lottie-animation>
